<template>
  <div class="alpha-bank-fallback">
    <div class="alpha-bank-fallback__text">
      Если у вас <b style="font-size: 20px"> не загрузилась</b> форма оплаты, перейдите по ссылке ниже 👇
    </div>

    <a
      :href="confirmationUrl || ''"
      target="_blank"
      rel="noopener noreferrer"
      class="alpha-bank-fallback__link"
    >
      {{ confirmationUrl }}
    </a>
  </div>
</template>

<script setup lang="ts">
interface Props {
  confirmationUrl?: string | null
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.alpha-bank-fallback {
  @apply text-center text-sm;

  &__text {
    @apply mb-2;
  }

  &__link {
    @apply inline-block break-all dark:text-white hover:text-blue-700 underline p-2 dark:hover:text-blue-200 transition-colors;
  }
}
</style>
